module.exports = __webpack_public_path__ + "img/banner.5bb1879d.jpg";